import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../ui/accordion.jsx';
import FormCard from '../../ui/form-card.jsx';

export const ImportGuide = () => {
  return (
    <FormCard className="flex">
      <Accordion className="w-full" type="single" collapsible>
        <AccordionItem className="border-0" value="item-1">
          <AccordionTrigger size="8">
            <h1 className="text-2xl font-bold">Como Importar Dados?</h1>
          </AccordionTrigger>
          <AccordionContent>
            <div className="flex w-full flex-col">
              <div className="mt-4 flex w-full flex-col gap-12">
                <div className="flex w-full flex-col gap-2">
                  <h2 className="text-lg font-semibold">
                    1. Carregar Ficheiro CSV
                  </h2>
                  <span className="ml-4 w-full">
                    Carregue um ficheiro CSV. Este ficheiro deve conter os dados
                    que pretende importar.
                  </span>
                </div>
                <div className="flex w-full flex-col gap-2">
                  <h2 className="text-lg font-semibold">
                    2. Seleção de Colunas
                  </h2>
                  <span className="ml-4 w-full">
                    Aqui, deverá selecionar as colunas correspondentes no
                    ficheiro CSV que carregou.
                  </span>
                </div>
                <div className="flex w-full flex-col gap-2">
                  <h2 className="text-lg font-semibold">
                    3. Opção de Apagar Registos
                  </h2>
                  <span className="ml-4 w-full">
                    (Opcional) Se desejar apagar todos os registos existentes
                    antes da importação, marque a caixa de seleção 'Apagar todos
                    os registos existentes'.
                  </span>
                </div>
                <div className="flex w-full flex-col gap-2">
                  <h2 className="text-lg font-semibold">4. Confirmar</h2>
                  <span className="ml-4 w-full">
                    Após completar os passos anteriores, será exibida uma
                    pré-visualização dos dados. Se tudo estiver correto, clique
                    em "Importar" para iniciar o processo de importação.
                  </span>
                </div>
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </FormCard>
  );
};
